





























































import merge from "lodash/merge";

import { Component, Prop, Vue } from "vue-property-decorator";
import { ServerResult } from "@/core/http/server_result";

export const ITEMS_LIST = "AGENT_DEALS_LIST";

@Component
export default class AgentDealList extends Vue {
  @Prop() agentId!: string;

  tableParams = {};
  documents = [];
  loading = false;
  lastMeta: any = {};

  onPageChange(page: string) {
    console.log("onPageChange", page);
    this.tableParams = merge(this.tableParams, {
      page
    });

    this.loadData();
  }

  loadData() {
    this.loading = true;

    (this as any)
      .$db([
        (this as any)
          .$q(ITEMS_LIST)
          .raw("documents.list")
          .action({
            columns: {
              id: "deal.id",
              expected_delivery_date: "deal.expected_delivery_date",
              name: "deal.name",
              client_name: "client.name",
              price: "deal.list_price",
              status_name: "status.name"
            },
            from: "s:deals",
            from_as: "deal",
            joins: [
              {
                join: "s:clients",
                as: "client",
                on: {
                  $eq: ["deal.client_id", "client.id"]
                }
              },
              {
                join: "s:statuses",
                as: "status",
                on: {
                  $eq: ["deal.status_id", "status.id"]
                }
              }
            ],
            where: {
              $eq: ["client.agent_id", { $: this.agentId }]
            },
            order: [{ $desc: ["deal.expected_delivery_date"] }],
            page_size: 100,
            page: parseInt((this.tableParams as any).page) || 1
          })
      ])
      .then((result: ServerResult) => {
        const opResult = result.getOperation(ITEMS_LIST).getContent();

        this.documents = opResult.documents;
        this.lastMeta = opResult.meta;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any) {
    this.$router.push({
      name: "deal-details",
      params: {
        id: row.id
      }
    });
  }

  // ---------------------------------------------------------------------------

  mounted() {
    this.loadData();
  }
}
